import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    Input,
    Injector,
    ElementRef,
    ChangeDetectorRef,
    SkipSelf,
    HostBinding,
} from '@angular/core';
import { ButtonComponent } from '@common/components/button/button.component';
import { arrowLeft } from '@icons';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'button[climbListViewButton]',
    templateUrl: './toolbar-list-view-button.component.html',
    styleUrls: ['./toolbar-list-view-button.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarListViewButtonComponent extends ButtonComponent implements OnInit {
    readonly icons = { arrowLeft } as const;

    @Input()
    @HostBinding('attr.aria-label')
    private ariaLabel = 'Open List View';

    constructor(
        injector: Injector,
        elementRef: ElementRef,
        @SkipSelf() cdr: ChangeDetectorRef,
    ) {
        super(injector, elementRef, cdr);
    }

    ngOnInit(): void {
        super.ngOnInit();
        super.onlyIcon = false;
        super.variant = 'ghost';
        super.size = 'sm';
    }
}
